import { __read } from "tslib";
import { useStyletron } from '../baseui';
import { useCallback } from 'react';
import rtlCSSJS from 'rtl-css-js';
import { useLatest } from '../hooks/useLatest';
import { useTheme } from '../theme/context';
var identity = function (x) { return x; };
/**
 * styletron returns new `styletronCSS` function each time the hook is called. This hook memorizes the css function and returns same reference every time.
 */
var useMemoizedStyletron = function () {
    var _a = __read(useStyletron(), 2), styletronCSS = _a[0], theme = _a[1];
    var ctx = useTheme();
    var cssRef = useLatest(styletronCSS);
    var decorator = ctx.direction === 'rtl' ? rtlCSSJS : identity;
    var css = useCallback(function (arg) { return cssRef.current(decorator(arg)); }, [cssRef, decorator]);
    return [css, theme];
};
export default useMemoizedStyletron;
